import { PAGE_MODE } from "../../../constants/constants";
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../framework/bar-button/BarButtonFw";
import { BasePage } from "../../../framework/pages/BasePage";
import GridFw, {
  COLUMN_DEFAULT,
  SELECTION_TYPE,
} from "../../../framework/grid/GridFw";
import FormFw from "../../../framework/form/FormFw";
import { getValidationEstacionModal } from "../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/getValidationEstacionModal";
import { LoadUtil } from "../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../util/RequestUtil";
import { EnvConstants } from "../../../EnvConstants";
import { UserUtil } from "../../../util/UserUtil";
import { MessageUtil } from "../../../util/MessageUtil";
import { LoadingUtil } from "../../../util/LoadingUtil";
import { EditarMuestraModel } from "../modals/EditarMuestrasModal";
import { debug } from "loglevel";

class ConfigurarPuntosSection extends BasePage {
  createPageProperties = (pageApi) => {
    return {
      validation: getValidationEstacionModal,
    };
  };

  componentDidMount() {
    const redirectCadena =
      JSON.parse(sessionStorage.getItem("redirect_cadena")) || {};
    if (redirectCadena?.redirect) {
      this.props.cambiarTabPanel(redirectCadena.redirectTab.toString(), 0);
      sessionStorage.removeItem("redirect_cadena");
    }
  }

  renderPage(pageApi) {
    const getForm = () => pageApi.getComponent("form");
    const getgrid_configurar_puntos = () =>
      pageApi.getComponent("grid_configurar_puntos");
    const getgrid_configurar_puntos_select = () =>
      pageApi.getComponent("grid_configurar_puntos_seleccionado");
    const storageCadena =
      pageApi.getParamId() === "0"
        ? JSON.parse(sessionStorage.getItem("storage_cadena"))
        : { id_ss: pageApi.name.id_ss };

    const barHeaderConfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SEARCH,
          label: "Agregar Análisis",
          onClick: () => {
            pageApi.showModal(
              AnalisisModalConfig({
                es_edicion: false,
                id_ss: storageCadena?.id_ss,
                cantidad: 1,
              }),
            );
          },
        },
      ],
    };

    const analisisConfig = {
      events: {
        afterAddEvent: (data) => {
          window.location.reload();
        },
      },
    };

    const AnalisisModalConfig = (param) => {
      const data = {
        id_ss: pageApi.name.id_ss || storageCadena?.id_ss,
        ...param,
      };

      return {
        width: "950px",
        maskClosable: false,
        component: (
          <EditarMuestraModel
            name={data}
            getParentApi={pageApi.getApi}
            config={analisisConfig}
          />
        ),
      };
    };

    const gridConfigurarPuntos = {
      layout: "vertical",
      title: "Puntos Disponibles",
      autoLoad: true,
      barHeader: barHeaderConfig,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "ID_EQUIPO_CAMPO",
      selection: { type: SELECTION_TYPE.MULTIPLE },
      onChangeSelection: (row, rows) => {
        const arrData = getgrid_configurar_puntos_select().getData() || [];
        let dataFilter = arrData.filter((el) => el.id_muestreo || el.id_muestreo_existente);
        const itemsNoEncontrados = [];

        rows.forEach((el) => {
          const index = dataFilter.findIndex(
            (item) => item.numero.toString() === el.numero.toString(),
          );

          if (index !== -1) {
            el.id_muestreo_existente = dataFilter[index]?.id_muestreo || el.id_muestreo_existente;
            dataFilter[index] = el;
          } else {
            itemsNoEncontrados.push(el);
          }
        });

        const datosFinales = [...dataFilter, ...itemsNoEncontrados];
        getgrid_configurar_puntos_select().setData(datosFinales);
      },
      load: {
        search: true,
        queryId: 878,
        params: {
          id_cadena: pageApi.getParamId(),
          id_ss: storageCadena?.id_ss,
          tipo_cadena: storageCadena?.tipo_cadena,
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 796,
        hideMessage: true,
        hideMessageError: true,
      },
      expandableAsync: async (record) => {
        let obj = {
          ...record,
          id_doc_cotizacion:
            getgrid_configurar_puntos()?.getData()?.id_doc_cotizacion,
        };

        const reqParams = LoadUtil.getReqParams({
          queryId: 883,
          params: () => ({
            id_cadena: pageApi.getParamId(),
            tipo_cadena: storageCadena?.tipo_cadena,
            id_rel_ss_estacion: obj.id_rel_ss_estacion || 0,
            parametros: obj.parametros || "",
          }),
        });

        const api = await RequestUtil.postData(
          EnvConstants.GET_URL_READ(),
          reqParams,
        )
          .then((resp) => resp.dataList)
          .catch(() => []);

        return (
          <table>
            <thead>
              <tr>
                <th>Parámetro</th>
                <th>Acreditador</th>
                <th>Sub Parametros</th>
              </tr>
            </thead>
            <tbody>
              {api.map((el, idx) => (
                <tr key={idx}>
                  <td>{el.analisis_concat}</td>
                  <td>{el.acreditacion}</td>
                  <td>{el.parametrosDes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      },
      fields: [
        { name: "numero", label: "Código M." },
        { name: "nombre_matriz", label: "Matriz" },
        { name: "estaciondes", label: "Estación" },
        { name: "descripcion", label: "Descripción" },
        { name: "coord_f", label: "Coordenada E" },
        { name: "coord_n", label: "Coordenada N" },
        {
          ...COLUMN_DEFAULT.VIEW,
          width: 40,
          color: "blue",
          title: "Ver Análisis",
          label: "Opciones",
          colSpan: 1,
          onClick: (value, row, index) => {
            pageApi.showModal(
              AnalisisModalConfig({
                id_doc_cotizacion: row.id_doc_cotizacion,
                id_rel_ss_estacion: row.id_rel_ss_estacion,
                id: row.id,
                grupo: row.descripcion_grupo,
                id_empresa: row.id_empresa,
                id_tipo_matriz: row.id_tipo_matriz,
                id_matriz: row.id_matriz,
                id_estacion: row.id_estacion,
                es_edicion: true,
              }),
            );
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const gridConfigurarPuntosSeleccionados = {
      title: "Puntos Seleccionados",
      autoLoad: true,
      pagination: {
        server: true,
        showSizeChanger: true,
      },
      rowId: "id_muestreo",
      load: {
        queryId: 880,
        params: { id_cadena: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 879,
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => { 
              LoadingUtil.loadHide();
              sessionStorage.removeItem("storage_cadena");

             if (resp?.dataObject == 1) {
              MessageUtil("error", resp.message, "");
             }
             else { 
                if (resp?.dataList?.length > 1) {
                  resp.dataList.forEach((el) => {
                    MessageUtil("success", el.mensaje, "");
                  });
                  this.props.history.push(
                    `/solicitudes-asignadas/solicitudes-asignadas/${getForm()?.getData()?.ID_SOLICITUD_SERVICIO || storageCadena?.id_ss}`,
                  );
                } else if (resp?.dataList?.length === 1) {
                  resp.dataList.forEach((el) => {
                    MessageUtil("success", el.mensaje, "");
                  });
                  const redirect = { redirectTab: 2, redirect: true };
                  sessionStorage.setItem("redirect_cadena", JSON.stringify(redirect));
                  window.location = `/solicitudes-asignadas/solicitudes-asignadas/cadenas/${resp?.dataList[0]?.id_cadena}`;
                  // getgrid_configurar_puntos_select().load({ params: { id_cadena: resp?.dataObject?.id_cadena } });
                } else if (!resp?.dataList) {
                  MessageUtil("success", resp.message, "");
                  window.location.reload();
                }
             } 
        },
        fnError: () => {
          LoadingUtil.loadHide();
        },
      },
      expandableAsync: async (record) => {
        const reqParams = LoadUtil.getReqParams({
          queryId:
            record.id_muestreo || record.id_muestreo_existente ? 881 : 883,
          params: () => ({
            id_muestreo: record.id_muestreo || record.id_muestreo_existente,
            id_cadena: pageApi.getParamId(),
            tipo_cadena: storageCadena?.tipo_cadena,
            id_rel_ss_estacion: record.id_rel_ss_estacion || 0,
            parametros: record.parametros || "",
          }),
        });

        const api = await RequestUtil.postData(
          EnvConstants.GET_URL_READ(),
          reqParams,
        )
          .then((resp) => resp.dataList)
          .catch(() => []);

        return (
          <table>
            <thead>
              <tr>
                <th>Parámetro</th>
                <th>Acreditador</th>
                <th>Sub Parametros</th>
              </tr>
            </thead>
            <tbody>
              {api.map((el, idx) => (
                <tr key={idx}>
                  <td>{el.parametro || el.analisis_concat}</td>
                  <td>{el.acreditacion || el.acreditacion}</td>
                  <td>{el.subparametro || el.parametrosDes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      },
      dataOptions: {
        out: { includeLabel: true },
      },
      fields: [
        {
          width: 40,
          ...COLUMN_DEFAULT.DELETE,
          color: "red",
          label: "Opciones",
          colSpan: 1,
          onClick: (value, row, index) => {
            getgrid_configurar_puntos_select().deleteItem(row.key);
          },
        },
        { name: "numero", label: "Código M." },
        { name: "nombre_matriz", label: "Matriz" },
        { name: "estaciondes", label: "Estación" },
        { name: "descripcion", label: "Descripción" },
        { name: "coord_f", label: "Coordenada E" },
        { name: "coord_n", label: "Coordenada N" },
        {
          ...COLUMN_DEFAULT.VIEW,
          width: 40,
          color: "blue",
          title: "Ver Análisis",
          label: "Opciones",
          colSpan: 1,
          onClick: (value, row, index) => {
            pageApi.showModal(
              AnalisisModalConfig({
                id_doc_cotizacion: row.id_doc_cotizacion,
                id_rel_ss_estacion: row.id_rel_ss_estacion,
                id: row.id,
                grupo: row.descripcion_grupo,
                id_empresa: row.id_empresa,
                id_tipo_matriz: row.id_tipo_matriz,
                id_matriz: row.id_matriz,
                id_estacion: row.id_estacion,
                es_edicion: true,
                id_muestreo:row.id_muestreo,
                numero:row.numero,
                id_cadena:row.id_cadena,
              }),
            );
          },
          fnVisible: (value, row, index) => { 
            return row?.es_cadena_bloqueado === 0;
          }
          
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const combinarValoresArr = (...arrays) => {
      const combinado = arrays.flat();
      return combinado.length > 0 ? true : false;
    };

    const barButtonConfigurarPuntos = {
      fields: [
        {
          ...BUTTON_DEFAULT.RETURN,
          label: "Retornar Inicio",
          onClick: () => {
            const pathBack =
              this.props?.history?.location?.state?.from ||
              `/solicitudes-asignadas/solicitudes-asignadas/${getForm()?.getData()?.ID_SOLICITUD_SERVICIO || storageCadena?.id_ss}`;
            this.props.history.push(pathBack);
          },
        },
        {
          ...BUTTON_DEFAULT.SAVE,
          label: "Guardar",
          onClick: () => {
            if (!storageCadena?.tipo_cadena && pageApi.getParamId() === "0") {
              this.props.history.push(
                `/solicitudes-asignadas/solicitudes-asignadas-admin`,
              );
            }

            const esEditado = combinarValoresArr(
              getgrid_configurar_puntos_select().getItemsNew(),
              getgrid_configurar_puntos_select().getItemsUpdate(),
              getgrid_configurar_puntos_select().getItemsDelete(),
            );

            if (esEditado) {
              LoadingUtil.loadShow();
              getgrid_configurar_puntos_select().save({
                params: {
                  id_cadena: pageApi.getParamId(),
                  id_usuario: UserUtil.getUserId(),
                  id_ss: storageCadena?.id_ss,
                  tipo_cadena: storageCadena?.tipo_cadena,
                },
              });
            }
          },
        },
        {
          ...BUTTON_DEFAULT.NEXT,
          label: "Continuar",
          onClick: () => {
            if (!storageCadena?.tipo_cadena && pageApi.getParamId() === "0") {
              this.props.history.push(
                `/solicitudes-asignadas/solicitudes-asignadas-admin`,
              );
            }

            getgrid_configurar_puntos_select().save({
              params: {
                id_cadena: pageApi.getParamId(),
                id_usuario: UserUtil.getUserId(),
                id_ss: storageCadena?.id_ss,
                tipo_cadena: storageCadena?.tipo_cadena,
              },
            });
            const redirect = { redirectTab: 2, redirect: true };
            sessionStorage.setItem("redirect_cadena", JSON.stringify(redirect));
            this.props.cambiarTabPanel("2", 0);
          },
        },
      ],
    };

    const formConfigurarPuntos = {
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 354,
        params: {
          ID_CADENA: pageApi.getParamId(),
        },
      },
      save: {
        queryId: 0,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      }, 
      title: "",
      collapsible: true,
      fields: [
        {
          label: "  ",
          fields: [
            { type: "hidden", name: "ID_SOLICITUD_SERVICIO" },
            {name: 'nro_ss_cadena', label: ' ',column: 7,readOnly: true},  
            {
              type: "select",
              name: "id_matriz",
              label: "Matriz",
              column: 6,
              load: {
                queryId: 885,
                params: {
                  id_cadena: pageApi.getParamId(),
                  tipo_cadena: storageCadena?.tipo_cadena,
                  id_ss: storageCadena?.id_ss,
                },
              },
              search: true,
              allowClear: true,
            },
            {
              type: "select",
              name: "id_analisis",
              label: "Analisis",
              column: 4,
              search: true,
              load: {
                queryId: 886,
                params: {
                  id_cadena: pageApi.getParamId(),
                  id_ss: storageCadena?.id_ss,
                  tipo_cadena: storageCadena?.tipo_cadena,
                },
              },
              multiple:true, 
              editable:true,
              allowClear: true,
            },
          ],
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const barButtonconfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SEARCH,
          label: "Buscar",
          onClick: () => {
            getgrid_configurar_puntos().load({
              params: {
                id_matriz: getForm()?.getData()?.id_matriz,
                id_analisis: getForm()?.getData()?.id_analisis,
              },
            });
          },
        },
      ],
    };

    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formConfigurarPuntos}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonconfig}
        />
        <GridFw
          name="grid_configurar_puntos"
          getParentApi={pageApi.getApi}
          config={gridConfigurarPuntos}
        />
        <GridFw
          name="grid_configurar_puntos_seleccionado"
          getParentApi={pageApi.getApi}
          config={gridConfigurarPuntosSeleccionados}
        />
        <BarButtonFw
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonConfigurarPuntos}
        />
      </>
    );
  }
}
export default ConfigurarPuntosSection;
